import { render, staticRenderFns } from "./lvshi_add.vue?vue&type=template&id=682f6637&scoped=true"
import script from "./lvshi_add.vue?vue&type=script&lang=js"
export * from "./lvshi_add.vue?vue&type=script&lang=js"
import style0 from "./lvshi_add.vue?vue&type=style&index=0&id=682f6637&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "682f6637",
  null
  
)

export default component.exports